/* Common Imports */

import React from "react";

/* Component Imports */

import { CheckOutlined } from "@mui/icons-material";
import { SvgIcon, Typography } from "@mui/material";
import { styled, useTheme } from "@mui/system";

const SectionContainer = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-start",
	flexDirection: "column",
	alignItems: "flex-start",
	borderRadius: "1.5rem",
	background: "#FFFFFF",
	padding: "1.5rem",
	gap: "1rem",
	border: "1px solid #6E3037",
	width: "100%",
	height: "320px",
	margin: "1rem 0rem 0rem 0rem",
	overflow: "hidden",
	[theme.breakpoints.down("sm")]: {
		margin: "0rem",
		gap: "0.75rem",
		padding: "1rem",
		height: "auto",
		overflow: "visible",
		borderRadius: "8px",
		border: "0.5px solid rgba(110, 48, 55, 0.50)",
	},
	"& :hover": {
		transform: "none",
	},
}));

const SvgDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "center",
	background: " #FFF7F0",
	padding: "0.5rem",
	borderRadius: "0.5rem",
	width: "auto",
}));

const SvgButtonDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
}));

const TextDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "flex-start",
	width: "100%",
	gap: "0.5rem",
}));

const InfoTitle = styled(Typography)(({ theme }) => ({
	fontWeight: "500",
	fontSize: "1.25rem",
	lineHeight: "2rem",
	color: "#000000",
	[theme.breakpoints.down("sm")]: {
		fontSize: "1rem",
		fontWeight: "600",
	},
}));

const ListItemWrapper = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "flex-start",
	gap: "0.75rem",
	marginBottom: "0.75rem",
}));

const boldWords = [
	"Build network",
	"channel partner",
	"owner property listing",
	"analytics",
	"leads & listings",
	"CRM tool",
	"₹60/month",
	"Unlimited",
	"Priority placement",
	"performance analytics",
	"Enhanced visibility",
	"₹660/week",
	"maximum exposure",
	"priority placement",
	"enhanced visibility",
	"Google, Instagram & Facebook",
	"₹180/month",
	"₹60/month",
	"property owner and expand your business",
	"residential",
	"commercial",
	"industrial",
	"agricultural",
	"warehouse",
	"Free",
	"AI-Powered",
];

const IntroListCard = ({ heading, list_text, icon }: { heading: string; list_text: string[]; icon: any }) => {
	const theme = useTheme();
	return (
		<React.Fragment>
			<SectionContainer>
				<SvgDiv>
					<SvgIcon
						component={icon}
						inheritViewBox={true}
						viewBox="0 0 80 80"
						sx={{
							width: "2.5rem",
							height: "2.5rem",
							fill: "none",
						}}
					/>
				</SvgDiv>
				<TextDiv>
					<InfoTitle>{heading}</InfoTitle>
				</TextDiv>
				{/* List rendering */}
				<div>
					{list_text.map((item, index) => {
						// Split the string using regex to match bold words
						const parts = item.split(new RegExp(`(${boldWords.join("|")})`, "gi"));

						return (
							<ListItemWrapper key={index}>
								<CheckOutlined
									sx={{
										color: "#6E3037",
										fontSize: "1.25rem",
										flexShrink: 0,
										marginTop: "0.125rem",
									}}
								/>
								<Typography
									variant="body1"
									sx={{
										fontSize: "1rem",
										[theme.breakpoints.down("sm")]: {
											fontSize: "0.875rem",
										},
									}}
								>
									{parts.map((part, i) =>
										boldWords.includes(part) ? (
											<span
												key={i}
												style={{ fontWeight: 600 }}
											>
												{part}
											</span>
										) : (
											part
										),
									)}
								</Typography>
							</ListItemWrapper>
						);
					})}
				</div>
			</SectionContainer>
		</React.Fragment>
	);
};

export default IntroListCard;
